import React, { useState, useEffect } from 'react';
import StoreHeader from './StoreHeader';
import StoreMap from './storeMap';
import { googleMapsInit } from '../../../utils/google-maps';
import StoreList from './storeList';
import { AlgoliaApiClient } from '../../../api/localisation/AlgoliaApiClient';
import { useLocalisationContext } from '../localisation/context/LocalisationContext';

const StoreContainer = () => {
  const [locations, setLocations] = useState([]);
  const [postcode, setPostcode] = useState('');
  const [currentLocation, setCurrentLocation] = useState({});
  const { selectedStore } = useLocalisationContext();

  const getLocations = async (query = '', options = {}, returnEmpty) => {
    if (returnEmpty) {
      setLocations([]);
    } else {
      const newLocations = await AlgoliaApiClient.getStores({
        query,
        approximateLocation: {
          longitude: options.longitude,
          latitude: options.latitude,
        },
        hitsPerPage: options.hitsPerPage,
      });
      setLocations(newLocations);
    }
  };

  const setSearchData = (postcode, aroundLatLng) => {
    setPostcode(postcode);
    setCurrentLocation(
      aroundLatLng
        ? {
            latitude: aroundLatLng.split(',')[0],
            longitude: aroundLatLng.split(',')[1],
          }
        : {}
    );
  };

  useEffect(() => {
    googleMapsInit(async () => {
      const algoliaStoreData = selectedStore ? await AlgoliaApiClient.getStore(selectedStore?.id) : null;
      if (algoliaStoreData) {
        const coordinates = {
          longitude: algoliaStoreData._geoloc.lng,
          latitude: algoliaStoreData._geoloc.lat,
        };
        setPostcode(algoliaStoreData.storeAddress.Postcode);
        setCurrentLocation(coordinates);
        getLocations('', coordinates);
      } else {
        getLocations('', { hitsPerPage: 1000 });
      }
    });
  }, []);

  useEffect(() => {
    if (postcode === '' && locations.length > 0 && locations.length <= 5 && locations[0].storeName) {
      const gtmData = {
        event: 'useCurrentLocationSearch',
        nearestStore: locations[0].storeName,
      };
      window.dataLayer.push(gtmData);
    } else if (postcode) {
      // Capturing updated search for postcode
      const gtmData = {
        event: 'storeFinderPostcodeSearch',
        postcodeSearched: postcode,
      };
      window.dataLayer.push(gtmData);
    }
  }, [locations, postcode]);
  return (
    <div>
      <StoreHeader getLocations={getLocations} setSearchData={setSearchData} />
      <StoreMap locations={locations} />
      <StoreList
        getLocations={getLocations}
        locations={locations}
        postcode={postcode}
        currentLocation={currentLocation}
        setSearchData={setSearchData}
      />
    </div>
  );
};

export default StoreContainer;
